"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var stylesImport = require("./DocumentCard.scss");
var Icon_1 = require("../../Icon");
var styles = stylesImport;
var DocumentCardStatus = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardStatus, _super);
    function DocumentCardStatus(props) {
        return _super.call(this, props) || this;
    }
    DocumentCardStatus.prototype.render = function () {
        var _a = this.props, statusIcon = _a.statusIcon, status = _a.status;
        var iconProps = {
            iconName: statusIcon, styles: {
                root: { padding: '8px' }
            }
        };
        return (React.createElement("div", { className: Utilities_1.css('ms-DocumentCardStatus', styles.status) },
            statusIcon && React.createElement(Icon_1.Icon, tslib_1.__assign({}, iconProps)),
            status));
    };
    return DocumentCardStatus;
}(Utilities_1.BaseComponent));
exports.DocumentCardStatus = DocumentCardStatus;
//# sourceMappingURL=DocumentCardStatus.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/DocumentCard/DocumentCardStatus.js
// module id = 1531
// module chunks = 0